import { OrderFilterParams } from 'api/types/data';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  OrdersHeader,
  OrdersTable,
  type OrdersTableProps,
} from '../components';

export interface OrdersViewProps extends OrdersTableProps {
  filter: OrderFilterParams;
  setFilter: (filter?: OrderFilterParams) => void;
}

export const OrdersView = ({
  filter,
  setFilter,
  ...tableProps
}: OrdersViewProps) => {
  const { t } = useTranslation();

  const { search } = filter;
  const noRowsLabel =
    (!!search && t('components.table.searchEmptyData')) ||
    t('components.table.emptyData');

  return (
    <Stack spacing={24}>
      <OrdersHeader
        search={search}
        setSearch={(value) => setFilter({ ...filter, search: value })}
      />
      <OrdersTable {...tableProps} noRowsLabel={noRowsLabel} />
    </Stack>
  );
};
